import { escapeHtml } from 'shared-helpers/common';
import { newlinesToLineBreak } from 'lib/helpers';

interface Props {
  text: string;
  style?: React.CSSProperties;
}

const TextWithLineBreaks = ({ text, style }: Props) => {
  if (!text) return null;

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: newlinesToLineBreak(escapeHtml(text))
      }}
      style={{ ...style }}
    />
  );
};

export default TextWithLineBreaks;
